<template>
<div>
  <div class="row">
    <div class="col-lg-8 col-lg-offset-2">
      <div class="page-header">
        <h1>Story listing</h1>
      </div>
      <div class="item-sorter">
        Order by:
          <a href="#" @click.prevent="sortByAuthor">Author</a>
          <a href="#" @click.prevent="sortByName">Story title</a>
          <a href="#" @click.prevent="sortByWord">Words count</a>
          <a href="#" @click.prevent="sortByPub">Published date</a>
          <a href="#" @click.prevent="sortByUp">Updated date</a>
      </div>
      <div v-for="story in story_list">
        <story-info :story="story"></story-info>
      </div>
    </div>
  </div>
</div>
</template>
<style>
  .item-sorter {text-align:right;font-size:85%}
</style>
<script language="text/babel">
  import StoryInfo from 'components/StoryInfo';
  function compareString(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  }

  function ffmktime(a) {
    const [m, d, y] = a.split('-');
    return `${y}-${m}-${d}`;
  }

  export default {
    data() {
      return {
        story_list: [],
      };
    },
    computed: {
      story_count() {
        return this.story_list.length;
      },
    },
    methods: {
      sortByName() {
        this.story_list.sort((a, b) => compareString(a.title, b.title));
      },
      sortByAuthor() {
        this.story_list.sort((a, b) => compareString(a.author, b.author));
      },
      sortByWord() {
        this.story_list.sort((a, b) => a.words - b.words);
      },
      sortByPub() {
        this.story_list.sort((a, b) => compareString(ffmktime(a.date_posted), ffmktime(b.date_posted)));
      },
      sortByUp() {
        this.story_list.sort((a, b) => compareString(ffmktime(a.date_updated), ffmktime(b.date_updated)));
      },
    },
    components: {
      StoryInfo,
    },
    route: {
      activate({ next }) {
        this.$http.get('/static/archive/archive.json')
          .then((res) => {
            this.story_list = res.data;
            next();
          });
      },
    },
  };
</script>



/** WEBPACK FOOTER **
 ** StoryList.vue?14347bd6
 **/